import {
	setFilters, setSidesAndVendors,
	setData, setLoading, setError,
} from '../reducers/dataIntegrityReducer';
import {
	GetDataIntegrityFilters,
	PostDataIntegrityData,
	PostDataIntegrityFiltersForTable,
} from '../requests/dataIntegrityRequests';
import dayjs from 'dayjs';

const DEFAULT_TABLE  = 'VTK S12 4G DATA';
const DEFAULT_MEDIAN = 30;

export const loadFilters = () => async (dispatch) => {
	try {
		const response = await GetDataIntegrityFilters();
		dispatch(setFilters(response.data));

		const tables = response.data?.tables ?? [];
		const table  = tables.includes(DEFAULT_TABLE) ? DEFAULT_TABLE : tables[0];
		if (!table) return;

		const dateTo   = dayjs().format('YYYY-MM-DD');
		const dateFrom = dayjs().subtract(30, 'day').format('YYYY-MM-DD');

		dispatch(loadData({
			tableFilter:  table,
			type:         null,
			sides:        null,
			vendors:      null,
			dateFrom,
			dateTo,
			medianWindow: DEFAULT_MEDIAN,
		}));
	} catch (e) {
		dispatch(setError('Error loading filters.'));
	}
};

export const loadSidesAndVendors = (params) => async (dispatch) => {
	try {
		const response = await PostDataIntegrityFiltersForTable(params);
		dispatch(setSidesAndVendors(response.data));
	} catch (e) {
		// silent fail
	}
};

export const loadData = (params) => async (dispatch) => {
	dispatch(setLoading(true));
	try {
		const { medianWindow = DEFAULT_MEDIAN, dateFrom, dateTo, ...rest } = params;

		// Extend backwards to cover the median window
		const extendedFrom = dayjs(dateFrom)
			.subtract(medianWindow, 'day')
			.format('YYYY-MM-DD');

		const response = await PostDataIntegrityData({
			...rest,
			dateFrom: extendedFrom,
			dateTo,
		});

		dispatch(setData({
			rows:        response.data,
			displayFrom: dateFrom,
			displayTo:   dateTo,
		}));
	} catch (e) {
		dispatch(setError('Error loading data.'));
	} finally {
		dispatch(setLoading(false));
	}
};